// extracted by mini-css-extract-plugin
module.exports = {"rowTitle":"PlayerNotification_rowTitle__1R5ih","title":"PlayerNotification_title__1JjSh","label":"PlayerNotification_label__1FfMI","liveDot":"PlayerNotification_liveDot__wkjmi"};